import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getContentData } from "../Utils/content";
import { appname } from "../Utils/constants";

const ImgComp = (props) => {

  const [imageBool, setImageBool] = useState(true);

  const storeSel = useSelector((state) => state);
  const appValue = storeSel.emailData?.appStatus;

  // useEffect(() => {
  //   const searchParams = new URLSearchParams(window.location.search);
  //   const appParam = searchParams.get('app');
 
  //   if(appParam)
  //   {
  //     if(appParam == "true") setImageBool(false);
  //     else setImageBool(true);
  //   }

  //   else setImageBool(true);
  // },[])

   if (appValue === true || appValue === "true") {
    return null; 
  }

  // if(!imageBool) return null;

  return (
    <>
      <div className="img-box">
        <img className="main-img" src="./asset/Img/sweat-payment-page.jpg" alt="Kartik Aryan And Shraddha Kapoor With Praveen Nair At Sweat Fit Wellness Studio" />
      </div>
    </>
  );
};

export default ImgComp;
